import { Option } from "@intentsify/types";
import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";
import { SingleAccountDetailsFilters } from "./SingleAccountDetails.types";

export const singleAccountDetailsFiltersAtom =
  atomWithReset<SingleAccountDetailsFilters>({
    names: [],
    locations: [],
  });

export const singleAccountDetailsNamesOptionsAtom = atom<Option[]>([]);

export const singleAccountDetailsLocationOptionsAtom = atom<Option[]>([]);
